// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_aqP","cls2":"ReferenceEvaluationPage-cls2_bDc ReferenceEvaluationPage-cls1_aqP"};